<form [formGroup]="rentalPropertyLicense">
  <div class="container">
    <div class="row gap-32 rental-property-container">
      <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
        <div class="form-row">
          <div class="form-col">
            <div class="field-caption">Department of Business and Professional Regulation License Number</div>
            <mat-form-field appearance="outline">
              <mat-label>DBPR license number</mat-label>
              <input matInput formControlName="departmentOfBusiness"
                 />
              <mat-icon matSuffix
                matTooltip="Florida State Business License (FORM: #DBPR HR-7028) for further information contact the DBPR at 850-487-1395."
                class="my-icon" iconPositionEnd>info_outline</mat-icon>
              <mat-error
                *ngIf="this.rentalPropertyLicense.get('departmentOfBusiness')?.errors?.['pattern'] && (rentalPropertyLicense.get('departmentOfBusiness')?.touched)">License
                number should not include spaces, leading zeros, or
                colons</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <mat-card style="width: 100%" appearance="outlined">
            <mat-card-content>
              <div class="form-row margin-bottom">
                <div class="form-col">Provide one of these fields in order</div>
              </div>
              <div class="form-row">
                <div class="form-col">
                  <div class="field-caption">Florida State Department of Revenue Sales Tax Certificate Number</div>
                  <mat-form-field appearance="outline">
                    <mat-label>Sales tax certificate number</mat-label>
                    <input matInput formControlName="taxCertificateNumber" appTaxCertificateNumber
                       />
                    <mat-error
                      *ngIf="this.rentalPropertyLicense.get('taxCertificateNumber')?.errors?.['pattern'] && (rentalPropertyLicense.get('taxCertificateNumber')?.touched)">The
                      certificate number format is 2 digits - 10 digits - 1
                      digit</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-row">
                <div class="row align-item-center gap-10">
                  <mat-checkbox formControlName="stateCertificateHasBeenApplied" color="primary" class="primary">
                    State Certificate has been applied for
                  </mat-checkbox>
                  <mat-icon
                    matTooltip="Each rental property must be registered with the Florida Department of Revenue for state sales tax purposes. If you have not yet received your certificate number please indicate in the 'applied for' checkbox above. For further information contact the Florida Department of Revenue at 941-343-0201 or https://floridarevenue.com.."
                    too aria-hidden="false">info_outline</mat-icon>
                </div>
              </div>
              <div class="form-row">
                <div class="form-col">
                  <div class="field-caption">If the business has not been registered, please state the reason why</div>
                  <mat-form-field appearance="outline">
                    <mat-label>Reason not registered</mat-label>
                    <input matInput formControlName="reasonWhy"
                       />
                  </mat-form-field>
                </div>
              </div>
              <div class="form-row" *ngIf="
                    rentalPropertyLicense.errors &&
                    (rentalPropertyLicense.get('reasonWhy')?.touched ||
                      rentalPropertyLicense.get('taxCertificateNumber')?.touched)
                  ">
                <p style="color: red">
                  If the property has not been registered, please state the
                  reason why.
                </p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
        <div class="form-row">
          <div class="form-col">
            <mat-form-field appearance="outline">
              <mat-label>City Certificate of Registration</mat-label>
              <input matInput formControlName="cityOfRegistration"
                placeholder="City Certificate of Registration" />
              <mat-icon matSuffix
                matTooltip="Anna Maria Island Contact Administration Office 941-708-6130 ext 110. City of Bradenton Contact City Hall 941-932-9425."
                class="my-icon" iconPositionEnd>info_outline</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <div class="form-col">
            <mat-form-field appearance="outline">
              <mat-label>Local Business Tax Receipt</mat-label>
              <input matInput formControlName="localBusinessTaxReceipt"
                placeholder="Local Business Tax Receipt" />
              <mat-icon matSuffix
                matTooltip=" City of Bradenton Contact City Hall 941-932-9425. Town of Longboat Key Contact Town Clerk 941-316-1999"
                class="my-icon" iconPositionEnd>info_outline</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>